import React from 'react'
import christmasOfferBanner from "./../../../../../Images/Blog/Christmas_offer/Banner.png";

const ChristmasOfferImg = () => {
  return (
    <div className="blogImg-content">
      <img src={christmasOfferBanner} alt="christmasOfferBanner" loading="lazy" />
    </div>
  )
}

export default ChristmasOfferImg
